import { render, staticRenderFns } from "./courierNumberDialog.vue?vue&type=template&id=3732c3b5&scoped=true"
import script from "./courierNumberDialog.vue?vue&type=script&lang=js"
export * from "./courierNumberDialog.vue?vue&type=script&lang=js"
import style0 from "./courierNumberDialog.vue?vue&type=style&index=0&id=3732c3b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3732c3b5",
  null
  
)

export default component.exports